export default "__VITE_ASSET__DsV3c6EN__"